import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/helper-components/success-toast";
import errorToast from "../../components/helper-components/error-toast";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionExpired = sessionStorage.getItem("sessionExpired");
    sessionStorage.removeItem("sessionExpired");
    localStorage.clear();
    navigate("/login");
    if (sessionExpired) {
      errorToast("Session expired");
    } else {
      successToast("Logged Out Successfully");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
